export class IRecommendationRepository {
  async getPharmInsightGuide(ediCodes, brn) {
    throw new Error('Method must be implemented');
  }
}
